import { useEffect, useRef } from "react";

export const useInterval = (
    callback: () => void,
    delay: number = 30000
  ) => {
    const savedCallback = useRef(callback);
  
    // The callback can change depending on state so remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        const id = setInterval(tick, delay);
        return () => {
            clearInterval(id);
        };
    }, [delay]);
  };